import { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const days = [
  { key: 0, label: "SUN" },
  { key: 1, label: "MON" },
  { key: 2, label: "TUE" },
  { key: 3, label: "WED" },
  { key: 4, label: "THU" },
  { key: 5, label: "FRI" },
  { key: 6, label: "SAT" },
];

// Custom styled toggle
const DayButton = styled(ToggleButton)(() => ({
  border: "none",
  borderRadius: "16px",
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: 600,
  boxShadow: "none",
  textAlign: "center",
  backgroundColor: "#f3f3f5",
  color: "#555",
  "&.Mui-selected": {
    backgroundColor: "#553cff",
    color: "white",
  },
  "&:hover": {
    backgroundColor: "#e6e6eb",
  },
}));

export default function DaysSelector({
  selectedDays,
  setSelectedDays,
}: {
  selectedDays?: number[];
  setSelectedDays: (days: number[]) => void;
}) {
  const { t } = useTranslation();

  const handleChange = (_: any, newDays: number[]) => {
    setSelectedDays(newDays);
  };

  return (
    <div className="mb-4">
      <h3 style={{ marginBottom: "12px" }}>اختر الايام</h3>

      <ToggleButtonGroup
        value={selectedDays}
        onChange={handleChange}
        aria-label="days"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {days.map((d) => (
          <DayButton key={d.key} value={d.key}>
            {t(d.label)}
          </DayButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
}
